import isSameDay from 'date-fns/is_same_day';

const isSameDayAsExcluded = (excludedDate: string | number | Date) => (
  date: string | number | Date,
) => isSameDay(excludedDate, date);

export default isSameDayAsExcluded;
